// AppAccessGate.js
//
// Build 25: route-level access control for suite apps. Wraps a route's
// element. If the user has access to the named app, renders children
// (typically the actual app component). Otherwise redirects to /dashboard
// with a flash message.
//
// Usage in Suite.js:
//   <Route path="/defect-tracker" element={
//     <AppAccessGate appId="defect-tracker" userProfile={userProfile}>
//       <DefectTrackerApp ... />
//     </AppAccessGate>
//   } />
//
// Build 25.1: two-tier check — org must enable AND user must be assigned.
// Admins are NOT bypassed; they're subject to the same checks so they
// can curate their own dashboards. The /admin route is enforced
// separately in Suite.js and is always reachable for admins.

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { userCanAccessApp } from './constants/appCatalog';

function AppAccessGate({ appId, userProfile, orgSettings, children }) {
  const location = useLocation();

  // Still loading the profile — don't redirect, just render nothing for
  // a tick. The parent route already guards on user + userProfile being
  // present, so this should rarely matter.
  if (!userProfile) return null;

  if (!userCanAccessApp(userProfile, appId, orgSettings)) {
    // Pass the attempted path so the dashboard can show a "you don't
    // have access to X" message if desired.
    return <Navigate to="/dashboard" state={{ deniedAppId: appId, from: location.pathname }} replace />;
  }

  return <>{children}</>;
}

export default AppAccessGate;
